export function isSuccessStatus(status: number) {
  return status >= 200 && status < 300
}

// Browser-specific messages for fetch failures caused by the user being offline
// or navigating away. CORS errors also surface as TypeError with the same
// messages — we accept that tradeoff since CORS issues are caught in development
// and would affect all users (visible through other monitoring).
export const CONNECTION_ERROR_MESSAGES = [
  'Failed to fetch', // Chrome/Edge
  'Load failed', // Safari
  'NetworkError when attempting to fetch resource', // Firefox
  'Network Error', // Axios XHR: offline, connection reset, navigating away
  'Observable cancelled prematurely', // Apollo: in-flight query cancelled (e.g. rapid refetch, unmount)
]

export function isConnectionError(
  error: Error | string | null | undefined,
): boolean {
  if (!error) return false
  const message = typeof error === 'string' ? error : error.message
  return CONNECTION_ERROR_MESSAGES.some(e => message?.includes(e))
}

// Abort errors — fired when the browser kills an in-flight request (e.g.
// component unmount, bfcache, tab backgrounding) without the user navigating away.
// Covers the browser Fetch API AbortError, Axios XHR cancellation, and Apollo
// GraphQL errors where the abort DOMException is wrapped in `networkError`.
export function isAbortError(
  error: (Error & { networkError?: Error | null }) | string | null | undefined,
): boolean {
  if (!error) return false
  if (typeof error !== 'string' && error.name === 'AbortError') return true
  const message = typeof error === 'string' ? error : error.message
  if (message?.includes('Request aborted')) return true
  if (typeof error !== 'string' && error.networkError) {
    return isAbortError(error.networkError)
  }
  return false
}
